import { render, staticRenderFns } from "./VerifyOtpCreatePassword.vue?vue&type=template&id=8556fd70&scoped=true"
import script from "./VerifyOtpCreatePassword.vue?vue&type=script&lang=js"
export * from "./VerifyOtpCreatePassword.vue?vue&type=script&lang=js"
import style0 from "./VerifyOtpCreatePassword.vue?vue&type=style&index=0&id=8556fd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8556fd70",
  null
  
)

export default component.exports